export default {
      id: "ic_filter_favourite_v2-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic_filter_favourite_v2-usage",
      toString: function () {
        return this.url;
      }
    }